/**
 * 問診フローの型定義
 */

import type { SimilarSearchResult } from '../similar_search/types';

// Re-export for convenience
export type { SimilarSearchResult };

/**
 * バリデーション定数
 */
export const VALIDATION = {
  // 固定部分（年代・性別・知りたいこと・期間・受診状況）は最大約100文字
  // 全角文字の場合のAPI のクエリ上限にあわせて470文字に制限
  MAX_FREE_TEXT_LENGTH: 470,
} as const;

/**
 * 年代（既存の Topics::TARGET_AGES に準拠）
 */
export type TargetAge =
  | 'NOT_SELECTED' // 未選択
  | 'INFANTS' // 乳幼児
  | 'UNDER_10' // 10歳未満
  | 'RANGE_10_19' // 10代
  | 'RANGE_20_29' // 20代
  | 'RANGE_30_39' // 30代
  | 'RANGE_40_49' // 40代
  | 'RANGE_50_59' // 50代
  | 'RANGE_60_69' // 60代
  | 'OVER_70'; // 70代以上

/**
 * 性別（既存の Topics::TARGET_GENDERS に準拠）
 */
export type TargetGender = 'NOT_SELECTED' | 'F' | 'M';

/**
 * 知りたいことカテゴリ
 */
export type CategoryOption =
  | 'should_go_hospital' // 病院に行くべき？
  | 'which_department' // 何科に行けばいい？
  | 'cause' // 原因は？
  | 'how_to_deal' // 対処法は？
  | 'medicine_treatment' // 薬や治療法は？
  | 'other'; // その他

/**
 * 期間（症状の継続期間）
 */
export type DurationOption =
  | 'today' // 今日初めて気づいた
  | 'yesterday' // 昨日から
  | 'few_days' // 2,3日以内
  | 'within_week' // 1週間以内から
  | 'over_week' // 1週間以上前から
  | 'no_symptom'; // 症状は無い・当てはまらない

/**
 * 受診状況
 */
export type MedicalVisitOption =
  | 'before' // 受診前
  | 'during' // 通院中（治療中）
  | 'after'; // 受診後

/**
 * 問診フォームデータ
 */
export interface InquiryFormData {
  keyword: string;
  targetAge: TargetAge;
  targetGender: TargetGender;
  category: CategoryOption | null;
  duration: DurationOption | null;
  medicalVisit: MedicalVisitOption | null;
  freeText: string;
}

/**
 * 問診フローのステップ（4ステップ）
 */
export type InquiryStep = 'category' | 'duration' | 'medicalVisit' | 'freeText';
